import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { EcomValidator } from 'src/app/ecom-services/ecom-validation';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { default as olarconfig } from '../../../assets/olarconfig.json';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { CompanySetting } from '@src/app/ecom-models/company-setting';
import { EcomSigninService } from '../ecom-signin-new/ecom-signin.service';
import { ToastService } from '@src/app/toast/toast.service';
import { User } from '@src/app/ecom-models/user';

@Component({
  selector: 'app-ecom-signin-loyalty',
  templateUrl: './ecom-signin-loyalty.component.html',
  styleUrls: ['./ecom-signin-loyalty.component.scss']
})
export class EcomSigninLoyaltyComponent implements OnInit {
  @ViewChild('scrollContainer', { static: false }) scrollContainer: ElementRef;

  public userForm: FormGroup;

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  selectedCountryISO: any = CountryISO.Malaysia;
  preferredCountries: CountryISO[] = [CountryISO.Malaysia, CountryISO.Australia, CountryISO.India, CountryISO.Singapore, CountryISO.Indonesia, CountryISO.Thailand];

  showOtp = false;
  userServiceBase: UserServiceBase;
  newuser = true;
  male = true;
  setting: CompanySetting;
  ageGroupList: { name: string; id: string; }[];
  today: Date;
  toastMessage: string = "";
  showToast = false;
  showSuccess = false;
  showAlreadyRegistered = false;
  constructor(public formBuilder: FormBuilder,
    public router: Router, public ecomservice: EComService,
    public activatedRoute: ActivatedRoute,
    private settingService: EcomSettingService,
    private toastService: ToastService,
    private signInService: EcomSigninService) {
    this.userServiceBase = new UserServiceBase();

    this.settingService.currentCompanySetting.subscribe(setting => {
      if (!setting) return;

      this.setting = setting;
    });

    this.toastService.message$.subscribe(message => {
      this.toastMessage = message;
    });
    this.toastService.visibility$.subscribe(visible => {
      this.showToast = visible;
    });

    this.ageGroupList = [
      { name: '10-20', id: 'TENTWE' },
      { name: '20-30', id: 'TWETHI' },
      { name: '30-40', id: 'THIFOU' },
      { name: '40-50', id: 'FOUFIF' },
      { name: '50-60', id: 'FIFSIX' },
      { name: '60-90', id: 'SIXNIN' },
    ];

    this.today = new Date();
  }

  // component initialize and load the required data
  ngOnInit() {
    this.initPage();
  }
  initPage() {
    this.userForm = this.formBuilder.group({
      phone: ['', Validators.compose([Validators.required])],
      name: ['', Validators.compose([Validators.required])],
      email: ['', Validators.compose([EcomValidator.emailValidator])],
      gender: [''],
      birthday: [''],
      age_group: ['TENTWE'],
      address: [''],
      state: [''],
      country: ['']
    });

    // // check if authtoken is there then redirect to profile page
    // if (this.cookie.cookie_authtoken !== '' && this.webstorage.localSt_user_id) {
    //   this.router.navigate(['profile']);
    // }
  }
  genderClick(gender) {
    this.male = gender === '1' ? true : false;
  }
  async onSignUpClick() {

    // if (this.userForm.invalid) {
    //   debugger
    //   this.toastService.show("cscsc");
    //   return;
    // }
    const setting = this.settingService.getCompanySetting();
    const userForm = this.userForm.getRawValue();
    const userService = this.settingService.getUserSerivce();
    const dialCode = userForm.phone.dialCode.replace(/\D/g, '');
    const phoneNumber = userForm.phone.number.replace(/\D/g, '');
    
    const model = {
      KindId: 0,
      AuthId: 0,
      Email: userForm.email,
      FirstName: userForm.name,
      LastName: "",
      Gender: this.male ? 'M' : 'F',
      LocationPkId: setting.oocls_location_pkid,
      CompanyPkid: setting.oocls_company_pkid,
      CompanyId: setting.oocls_company_id,
      JoinLoyalty: true,
      DialCode: dialCode,
      PhoneNumber: phoneNumber,
      OrderId: userService.lastOrderPkid,
      Birthday: userForm.birthday,
      AgeGroup: userForm.age_group,
      Address: userForm.address,
      State: userForm.state,
      Country: userForm.country,
    }

    const res = await this.signInService.verifyUser(model).toPromise();
    if(res.isSuccess){
      userService.lastOrderPkid = 0;
      this.settingService.setUserSerivce(userService);
    }
    this.showSuccess = res.status === 200;
    this.showAlreadyRegistered = res.status === 202;
    this.scrollContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onClickPrivacy() {
    window.open('./assets/media/Olarme_policy.pdf', '_blank');
  }

}
